import metadata from "./block.json";

/**
 * Standaardcopy uit block.json, zodat editor, frontend en tests dezelfde
 * defaults gebruiken. Lege attributen vallen hierop terug.
 */
export const DEFAULT_COPY = Object.fromEntries(
	Object.entries(metadata.attributes)
		.filter(([, spec]) => spec.type === "string")
		.map(([key, spec]) => [key, spec.default ?? ""])
);
